import { ResourceOptions } from 'react-admin';
import { FaThumbtack } from 'react-icons/fa';
import { Resources } from '../resource';

export { default as list } from './List';

export const name = Resources.perpsV1Pins;
export const icon = FaThumbtack;
export const options: ResourceOptions = {
  label: 'resource.perpsV1Pins',
};
